export default "__VITE_ASSET__n9ElYbZL__"